import { BdsText } from "@buildertrend/components";

import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";

import "./UserInfoViewDisplay.less";

export interface IUserInfoViewDisplayProps {
    addedByUserName?: string;
    addedByUserDate?: Date;
    updatedByUserName?: string;
    updatedByUserDate?: Date;
}

const UserInfoViewDisplay = ({
    addedByUserName,
    addedByUserDate,
    updatedByUserName,
    updatedByUserDate,
}: Readonly<IUserInfoViewDisplayProps>) => {
    return (
        <div className="flex flex-col userInfoViewDisplay">
            {updatedByUserName && updatedByUserDate && (
                <>
                    <div className="flex flex-row">
                        <BdsText
                            className="userAction"
                            size="normal-sm"
                            text={
                                <span>
                                    Updated by <strong>{updatedByUserName}</strong>
                                </span>
                            }
                        />
                    </div>
                    <div className="flex flex-row updatedBy">
                        <BdsText
                            size="normal-sm"
                            text={
                                <DateDisplayDate
                                    value={updatedByUserDate}
                                    showTime
                                    showDayOfWeek
                                    data-testid="updatedByUserDate"
                                />
                            }
                        />
                    </div>
                </>
            )}
            {addedByUserName && addedByUserDate && (
                <>
                    <div className="flex flex-row">
                        <BdsText
                            className="userAction"
                            size="normal-sm"
                            text={
                                <span>
                                    Created by <strong>{addedByUserName}</strong>
                                </span>
                            }
                        />
                    </div>
                    <div className="flex flex-row">
                        <BdsText
                            size="normal-sm"
                            text={
                                <DateDisplayDate
                                    value={addedByUserDate}
                                    showTime
                                    showDayOfWeek
                                    data-testid="addedByUserDate"
                                />
                            }
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default UserInfoViewDisplay;
